import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '0 auto',
    marginTop: 20,
    paddingTop: 20,
  },
  buttonWrapper: {
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'space-around',
  },
  button: {
    margin: '20px 10px 20px 10px',
  },
  closeIconButton: {
    position: 'absolute',
    top: 2,
    right: 2,
  },
  text: {
    maxWidth: 380,
    whiteSpace: 'pre-line',
  },
  closeIcon: {},
  title: {},
}))

export default useStyles
